/**
 * BetaRibbon: fascia diagonale "BETA" fissata nell'angolo in alto a sinistra
 * della viewport. Pensata per essere montata una sola volta al livello più alto
 * dell'app, così da restare visibile su ogni rotta (pagine pubbliche, login e
 * app autenticata) senza duplicazioni.
 *
 * È `position: fixed` con `pointer-events: none`, quindi non intercetta i click
 * sugli elementi sottostanti (incluso il logo in navbar).
 */
export function BetaRibbon() {
  return (
    <div className="beta-ribbon" role="note" aria-label="Beta version">
      <span className="beta-ribbon__band">BETA</span>
    </div>
  );
}

export default BetaRibbon;
